import api from './api';

export const studentApplicationService = {
    async getMyApplications(params = {}) {
        const response = await api.get('/student-application/mine', { params });
        return response.data;
    },

    async getApplicationsByProgram(programType, params = {}) {
        const response = await api.get(
            `/student-application/program/${programType}`,
            {
                params,
            }
        );
        // The server returns { applications, total, limit, offset }. Unwrap to
        // the applications array: every consumer (the SI/LA coordinator
        // dashboards) treats this as an array and calls .filter()/.length on
        // it, and this mirrors applicationService.getApplicationsByProgram.
        return response.data.applications;
    },

    async getApplicationById(applicationId) {
        const response = await api.get(`/student-application/${applicationId}`);
        return response.data;
    },

    async createApplication(applicationData) {
        const response = await api.post(
            '/student-application',
            applicationData
        );
        return response.data;
    },

    async updateApplication(applicationId, updates) {
        const response = await api.put(
            `/student-application/${applicationId}`,
            updates
        );
        return response.data;
    },

    async submitApplication(applicationId) {
        const response = await api.post(
            `/student-application/${applicationId}/submit`
        );
        return response.data;
    },

    async withdrawApplication(applicationId, reason) {
        const response = await api.post(
            `/student-application/${applicationId}/withdraw`,
            {
                reason,
            }
        );
        return response.data;
    },

    async updateStatus(
        applicationId,
        { status, notes, courseId, fromStatus } = {}
    ) {
        const response = await api.post(
            `/student-application/${applicationId}/status`,
            {
                status,
                notes,
                courseId,
                fromStatus,
            }
        );
        return response.data;
    },

    async respondToOffer(applicationId, action) {
        const response = await api.post(
            `/student-application/${applicationId}/respond`,
            { action }
        );
        return response.data;
    },

    /**
     * Replace a submitted application's resume copy with the student's
     * current profile resume. The previous copy moves to the application's
     * resume history.
     *
     * @param {string} applicationId
     * @returns {Promise<object>} The updated application.
     */
    async useProfileResume(applicationId) {
        const response = await api.post(
            `/student-application/${applicationId}/resume/use-profile`
        );
        return response.data;
    },

    /**
     * The resume file as a blob. It needs the signed-in user's token, which a
     * plain link cannot send.
     *
     * @param {string} applicationId
     * @returns {Promise<Blob>}
     */
    async downloadResume(applicationId) {
        const response = await api.get(
            `/student-application/${applicationId}/resume`,
            { responseType: 'blob' }
        );
        return response.data;
    },
};

export default studentApplicationService;
